const e = {
  name: "AdyenAFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 2H2.29V7H12.52C12.671 7 12.8206 7.02975 12.9601 7.08754C13.0996 7.14533 13.2264 7.23004 13.3332 7.33683C13.44 7.44361 13.5247 7.57039 13.5825 7.70991C13.6403 7.84944 13.67 7.99898 13.67 8.15V17H11.48C11.175 17 10.8825 16.8788 10.6668 16.6632C10.4512 16.4475 10.33 16.155 10.33 15.85V9.5H6C4.93913 9.5 3.92172 9.92143 3.17157 10.6716C2.42143 11.4217 2 12.4391 2 13.5V18C2 19.0609 2.42143 20.0783 3.17157 20.8284C3.92172 21.5786 4.93913 22 6 22H22V6C22 4.93913 21.5786 3.92172 20.8284 3.17157C20.0783 2.42143 19.0609 2 18 2Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as AdyenAFilled
};
